module.exports = __webpack_public_path__ + "img/gmb_pl.74758744.gif";